(() => {
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (mobileMenu) {
    mobileMenu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        mobileMenu.removeAttribute('open');
        mobileMenu.querySelector('summary')?.focus();
      }
    });

    mobileMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => mobileMenu.removeAttribute('open'));
    });
  }

  document.querySelectorAll('[data-product-variants]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const form = select.closest('form');
      const idInput = form?.querySelector('input[name="id"]');
      const price = form?.closest('[data-product-root]')?.querySelector('[data-product-price]');
      if (idInput) idInput.value = select.value;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
    });
  });

  document.querySelectorAll('[data-racer-attract]').forEach((attract) => {
    const title = attract.querySelector('[data-attract-title]');
    const demo = attract.querySelector('[data-attract-demo]');
    const video = attract.querySelector('[data-attract-video]');
    const playButton = attract.querySelector('[data-attract-play]');
    const idleDelay = Number(attract.dataset.idleDelay) || 18000;
    const demoDuration = Number(attract.dataset.demoDuration) || 32000;
    const startTime = Math.max(0, Number(attract.dataset.startTime) || 0);
    const activityEvents = ['pointerdown', 'keydown', 'touchstart', 'wheel', 'scroll'];
    let idleTimer;
    let demoTimer;
    let active = false;
    let preparing = false;
    let preparationId = 0;

    if (!title || !demo || !video) return;

    const scheduleDemo = () => {
      window.clearTimeout(idleTimer);
      idleTimer = window.setTimeout(startDemo, idleDelay);
    };

    const stopDemo = () => {
      window.clearTimeout(demoTimer);
      preparationId += 1;
      preparing = false;
      active = false;
      attract.classList.remove('is-attracting');
      demo.setAttribute('aria-hidden', 'true');
      demo.setAttribute('tabindex', '-1');
      title.removeAttribute('aria-hidden');
      video.pause();
      try {
        video.currentTime = startTime;
      } catch (error) {
        // Some browsers briefly prevent seeking while changing media state.
      }
      scheduleDemo();
    };

    const startDemo = () => {
      if (document.hidden || active || preparing) return;
      preparing = true;
      const currentPreparation = ++preparationId;

      try {
        video.currentTime = startTime;
      } catch (error) {
        // Playback below will load enough media for the requested seek.
      }

      const revealDecodedFrame = () => {
        if (!preparing || currentPreparation !== preparationId || document.hidden) return;
        preparing = false;
        active = true;
        title.setAttribute('aria-hidden', 'true');
        demo.setAttribute('aria-hidden', 'false');
        demo.removeAttribute('tabindex');
        attract.classList.add('is-attracting');

        const requestedEndTime = startTime + (demoDuration / 1000);
        const endTime = Math.min(requestedEndTime, video.duration || requestedEndTime);
        const remainingDuration = Math.max(0, (endTime - video.currentTime) * 1000);
        demoTimer = window.setTimeout(stopDemo, remainingDuration);
      };

      video.play().then(() => {
        if (!preparing || currentPreparation !== preparationId) return;
        if (typeof video.requestVideoFrameCallback === 'function') {
          video.requestVideoFrameCallback(revealDecodedFrame);
        } else {
          const revealWhenRenderable = () => {
            if (!preparing || currentPreparation !== preparationId) return;
            if (video.readyState >= 2) {
              window.requestAnimationFrame(() => window.requestAnimationFrame(revealDecodedFrame));
            } else {
              video.addEventListener('loadeddata', revealWhenRenderable, { once: true });
            }
          };
          revealWhenRenderable();
        }
      }).catch(stopDemo);
    };

    const registerActivity = (event) => {
      if (event.type === 'visibilitychange') {
        if (document.hidden) {
          window.clearTimeout(idleTimer);
          if (active || preparing) stopDemo();
        } else {
          scheduleDemo();
        }
        return;
      }

      if (active || preparing) stopDemo();
      else scheduleDemo();
    };

    demo.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      stopDemo();
    });
    playButton?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      window.clearTimeout(idleTimer);
      startDemo();
    });
    video.addEventListener('ended', stopDemo);
    video.addEventListener('timeupdate', () => {
      const requestedEndTime = startTime + (demoDuration / 1000);
      const endTime = Math.min(requestedEndTime, video.duration || requestedEndTime);
      if (active && video.currentTime >= endTime - 0.25) stopDemo();
    });
    activityEvents.forEach((eventName) => {
      window.addEventListener(eventName, registerActivity, { passive: true });
    });
    document.addEventListener('visibilitychange', registerActivity);
    scheduleDemo();
  });
})();
